import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { PermitVehicle } from "common/types/permits";

export interface VehiclesListSectionProps {
  vehicles: PermitVehicle[];
  maxHeight?: number;
}

export const VehiclesListSection: React.FC<VehiclesListSectionProps> = ({ vehicles, maxHeight = 200 }) => {
  if (!vehicles || vehicles.length === 0) {
    return null;
  }

  return (
    <Box mb={3}>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Vehicles ({vehicles.length})
      </Typography>
      <Box sx={{ maxHeight, overflowY: "auto" }}>
        <List dense disablePadding>
          {vehicles.map((vehicle) => (
            <ListItem key={vehicle.registeredVehicleId} disableGutters>
              <ListItemText
                primary={
                  <Typography sx={{ fontFamily: "monospace" }}>
                    {vehicle.registeredVehicle?.licensePlate || "—"} {vehicle.registeredVehicle?.stateCode || ""}
                  </Typography>
                }
                secondary={
                  vehicle.registeredVehicle
                    ? [vehicle.registeredVehicle.year, vehicle.registeredVehicle.make, vehicle.registeredVehicle.model]
                        .filter(Boolean)
                        .join(" ") || "—"
                    : "—"
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default VehiclesListSection;
